<div [formGroup]="parentForm" *ngIf="patient">
<div class="patient-fields">

            <div class="patient-fields-block">
              <div class="field-row name-dob-row">
                  <div class="item flex-name">
                    <mat-form-field [hideRequiredMarker]="false">
                      <mat-label>FIRST NAME</mat-label>
                      <input matInput type="text" formControlName="firstName" [ngClass]="{'has-error':parentForm.get('firstName').invalid}" class="bigfont" autocomplete="off" required>

                      <mat-error *ngIf="parentForm.get('firstName').invalid">FIRST NAME IS REQUIRED</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="item flex-name">
                    <mat-form-field [hideRequiredMarker]="false">
                      <mat-label>LAST NAME</mat-label>
                      <input matInput type="text" formControlName="lastName" [ngClass]="{'has-error':parentForm.get('lastName').invalid}" class="bigfont" autocomplete="off" required>
                      <mat-error *ngIf="parentForm.get('lastName').invalid">LAST NAME IS REQUIRED</mat-error>
                    </mat-form-field>
                  </div>
                  <div class="item flex-preferred">
                    <mat-form-field>
                      <mat-label>PREFERRED NAME</mat-label>
                      <input matInput type="text" formControlName="preferredName" placeholder="Optional" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-dob">
                    <mat-form-field class="date">
                      <mat-label>DATE OF BIRTH</mat-label>
                      <input matInput [matDatepicker]="dob" (blur)="blurDate()" formControlName="dob" autocomplete="off">
                      <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                      <mat-datepicker #dob></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>

              <div class="field-row">
                  <div class="item flex-address">
                    <mat-form-field>
                      <mat-label>ADDRESS</mat-label>
                      <input matInput type="text" formControlName="address" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-city">
                    <mat-form-field>
                      <mat-label>CITY</mat-label>
                      <input matInput type="text" formControlName="city" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-state">
                    <mat-form-field>
                      <mat-label>STATE</mat-label>
                      <input matInput aria-label="STATE" [matAutocomplete]="auto" (change)="updateState($event)" [formControl]="stateCtrl" formControlName="state" autocomplete="off">
                      <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let state of filteredStates | async" [value]="state.abbreviation">
                          <span>{{ state.abbreviation }} - {{ state.name }}</span>
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                  </div>
                  <div class="item flex-zip">
                    <mat-form-field>
                      <mat-label>ZIP</mat-label>
                      <input matInput type="text" formControlName="zip" autocomplete="off">
                    </mat-form-field>
                  </div>
                </div>

              <div class="field-row single-line-row">
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <mat-label>CELL PHONE</mat-label>
                      <input matInput class="bigfont" type="tel" formControlName="cell"  mask="(000) 000-0000 x9999" [specialCharacters]="[ ' ', '(', ')', '-', 'x' ]" autocomplete="off">
                    </mat-form-field>
                  </div>
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <mat-label>HOME PHONE</mat-label>
                      <input matInput class="bigfont" type="tel" formControlName="phone" autocomplete="off" mask="(000)000-0000 x9999" [specialCharacters]="[ ' ', '(', ')', '-', 'x' ]">
                    </mat-form-field>
                  </div>
                  <div class="item flex-quarter">
                    <mat-form-field>
                      <mat-label>EMAIL</mat-label>
                      <input matInput type="email" formControlName="email" autocomplete="off">
                    </mat-form-field>
                    <div class="alert alert-danger" *ngIf="0">A valid email is required.</div>
                  </div>
                </div>
            </div>

            <div class="patient-fields-block">
              <div class="field-row">
                <div class="item flex-quarter">
                  <mat-form-field>
                    <mat-label>OCCUPATION</mat-label>
                    <input matInput type="text" formControlName="occupation" autocomplete="off">
                  </mat-form-field>
                </div>
                <div class="item flex-quarter">
                  <mat-form-field>
                    <mat-label>INTERESTS</mat-label>
                    <input matInput type="text" formControlName="interests" autocomplete="off">
                  </mat-form-field>
                </div>
                <div class="item flex-quarter">
                  <mat-form-field>
                    <mat-label>HOW DID YOU FIND US?</mat-label>
                    <mat-select formControlName="howDidYouFindUs" autocomplete="off">
                      <mat-option *ngFor="let howDidYouFindUsType of howDidYouFindUsTypes" [(value)]="howDidYouFindUsType.value">
                      {{ howDidYouFindUsType.viewValue }}
                    </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="item flex-quarter" *ngIf="parentForm.get('howDidYouFindUs').value=='OTHER'">
                  <mat-form-field>
                    <mat-label>OTHER</mat-label>
                    <input matInput type="text" [(value)]="parentForm.value.howDidYouFindUsOther" formControlName="howDidYouFindUsOther" autocomplete="off">
                  </mat-form-field>
                </div>
              </div>
            </div>
</div>

            <div class="patient-summary-bar">
              <div class="patient-summary-item">
                <b>Last Exam</b>
                <strong>{{ parentForm.get('lastExam')?.value | date:'MM/dd/yyyy' }}</strong>
              </div>
              <div class="patient-summary-item">
                <b>Account Balance</b>
                <strong>{{ accountBalance | currency }}</strong>
              </div>
              <div class="patient-summary-item">
                <b>Available Credit</b>
                <strong>{{ creditAmount | currency }}</strong>
                <button
                  type="button"
                  class="summary-history"
                  [matMenuTriggerFor]="creditHistoryMenu"
                  (menuOpened)="loadCreditHistory()"
                >
                  History
                </button>
                <mat-menu #creditHistoryMenu="matMenu" class="log open-sans credit-log" xPosition="before">
                  <h3 class="ao-log-title">Credit history</h3>
                  <table class="ao-log">
                    <tr *ngIf="creditHistoryLoading">
                      <td>Loading</td>
                    </tr>
                    <tr *ngIf="!creditHistoryLoading && !creditHistory.length">
                      <td>No credit history</td>
                    </tr>
                    <tr *ngFor="let row of creditHistory">
                      <td>{{ row.label }}</td>
                      <td>
                        <mat-icon>event</mat-icon>
                        {{ row.date | date:'M/d/yy' }}
                      </td>
                      <td class="sig" *ngIf="row.initials">
                        <mat-icon>gesture</mat-icon>
                        {{ row.initials }}
                      </td>
                    </tr>
                  </table>
                </mat-menu>
              </div>
            </div>
    </div>
